var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPlayInactive(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1532_2136)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.7196 43.1667C21.416 40.9508 21.4068 30.1665 21.4702 27.8794H23.9978V24.5154H21.6784L24.0703 17.8857L22.4741 16.3085L19.675 16.3088V14.7632H22.1527V11.4485L19.675 11.4481V9H16.3202V11.4481H13.8425V14.7629H16.3202V16.3085H13.5259L11.9297 17.8857L14.3216 24.5154H12.0022V27.8794H14.5297C14.5884 30.1667 14.5884 40.9466 9.28038 43.1667L9 43.2829V47H27V43.2829L26.7196 43.1667Z",
    fill: "#707070"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.6148 14.5197V16.2562L16.3852 16.2559V14.5194H14V11.3447H16.3852V9H19.6148V11.3447L22 11.345V14.5197H19.6148Z",
    fill: "#B3B3B3"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1532_2136"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(6 6)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayInactive);
export default __webpack_public_path__ + "static/media/play-inactive.5648d9fcffaad271659861edb21fb755.svg";
export { ForwardRef as ReactComponent };